import z from "zod";

export const AddressSchema = z.object({
  line1: z.string(),
  line2: z.string().optional(),
  city: z.string(),
  postcode: z.string().optional(),
});

export type Address = z.infer<typeof AddressSchema>;

// export type Address = {
//   line1: string;
//   line2?: string;
//   city: string;
//   postcode?: string;
// };
